export default __webpack_public_path__ + "static/media/midhiring.56dcdb7e.jpg";